import { useNavigate } from 'react-router-dom';
import { useContext, useEffect } from 'react';
import { CompanyContext } from 'index';
import useSearchParams from 'hooks/useSearchParams';
import authService from 'store/auth/service';
import useFormik from 'hooks/useFormik';
import { validationSchema } from './validationSchema';
import { LoginPage } from '../../paths';
import { ContentBox } from 'components/ContentBox';
import { CompanyLogo } from 'components/CompanyLogo';
import FormInputRow from 'components/Form/InputRow';
import FormInput from 'components/Form/Input';
import ActionRow from 'components/ActionRow';
import ButtonWithArrowIcon from 'components/Buttons/ButtonWithArrowIcon';
import Loader from 'components/Loaders/Loader';

import styles from './styles.module.scss';

export const ResetPasswordPage = () => {
  const navigate = useNavigate();
  const company = useContext(CompanyContext);
  const accessToken = useSearchParams().accessToken;

  const [changePassword, { isLoading, status: confirmationStatus }] =
    authService.endpoints.changePassword.useMutation();

  const { getFieldProps, getFieldErrorProp, handleSubmit } = useFormik({
    initialValues: {
      password: '',
      confirmPassword: '',
    },
    validationSchema,
    onSubmit: (value) => {
      changePassword({ password: value.password, accessToken });
    },
  });

  useEffect(() => {
    if (confirmationStatus === 'fulfilled') {
      navigate(LoginPage);
    }
  }, [confirmationStatus]);

  return (
    <div className={styles.root}>
      <ContentBox className={styles.content}>
        <CompanyLogo src={company.logo} responsive={true} />
        <div className={styles.description}>Please enter your new password</div>
        <form onSubmit={handleSubmit} className={styles.form}>
          <FormInputRow
            className={styles.inputRow}
            required
            {...getFieldErrorProp('password')}
          >
            <FormInput
              {...getFieldProps('password')}
              type="password"
              autoComplete="password"
              placeholder={'Password'}
            />
          </FormInputRow>
          <FormInputRow
            className={styles.inputRow}
            required
            {...getFieldErrorProp('confirmPassword')}
          >
            <FormInput
              {...getFieldProps('confirmPassword')}
              type="password"
              autoComplete="password"
              placeholder={'Confirm password'}
            />
          </FormInputRow>
          <ActionRow style="space-between" className={styles.actionRow}>
            <ButtonWithArrowIcon type="submit" disabled={isLoading}>
              Submit
            </ButtonWithArrowIcon>
          </ActionRow>
          {isLoading && <Loader />}
        </form>
      </ContentBox>
    </div>
  );
};
